import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=30b8895d&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=30b8895d&lang=less"
import style1 from "./Register.vue?vue&type=style&index=1&id=30b8895d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b8895d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30b8895d')) {
      api.createRecord('30b8895d', component.options)
    } else {
      api.reload('30b8895d', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=30b8895d&scoped=true", function () {
      api.rerender('30b8895d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/Register.vue"
export default component.exports